import { Accordion, AccordionDetails } from '@mui/material';
import { DocumentsContext } from 'Context/DocumentsContext';
import { useContext } from 'react';
import { DocumentDetail } from '../AccordionDocument/DocumentDetail';
import { NoResults } from './NoResults';

export const AdvancedFilterResults = () => {
  const { documents } = useContext(DocumentsContext);

  return (
    <Accordion
      expanded={true}
      sx={{
        boxShadow: 'none',
        borderRadius: '0 16px 16px 0',
        '&:before': { display: 'none' },
      }}
    >
      <AccordionDetails
        onClick={(e: React.MouseEvent) => {
          e.stopPropagation();
        }}
        sx={{
          p: '0 24px',
          borderLeft:
            documents.filteredResults.length === 0
              ? undefined
              : '3px solid #D59DFF',
        }}
      >
        {documents.filteredResults.length === 0 ? (
          <NoResults />
        ) : (
          documents.filteredResults.map((documentItem, index: number) => {
            return <DocumentDetail key={index} data={documentItem} />;
          })
        )}
      </AccordionDetails>
    </Accordion>
  );
};
